import type {
  CollectionActions,
  CollectionStateSlice,
  Reference,
} from '@freelancer/datastore/core';
import {
  mergeDocuments,
  mergeWebsocketDocuments,
  removeDocumentById,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformSecurityPhoneRequest } from './security-phone-requests.transformers';
import type { SecurityPhoneRequestsCollection } from './security-phone-requests.types';

const PAYLOAD_TYPE = 'securityPhoneRequests';

export function securityPhoneRequestsReducer(
  state: CollectionStateSlice<SecurityPhoneRequestsCollection> = {},
  action: CollectionActions<SecurityPhoneRequestsCollection>,
): CollectionStateSlice<SecurityPhoneRequestsCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === PAYLOAD_TYPE) {
        const { result, ref, order } = action.payload;

        return mergeDocuments<SecurityPhoneRequestsCollection>(
          state,
          transformIntoDocuments(
            result ? [result] : undefined,
            transformSecurityPhoneRequest,
            ref.path.authUid,
          ),
          order,
          ref,
        );
      }

      return state;
    }

    case 'API_DELETE_SUCCESS': {
      if (action.payload.type === PAYLOAD_TYPE) {
        const { originalDocument, ref } = action.payload;
        return removeDocumentById<SecurityPhoneRequestsCollection>(
          ref,
          state,
          originalDocument.id,
        );
      }

      return state;
    }

    case 'WS_MESSAGE': {
      if (action.payload.type === 'securePhoneUpdated') {
        const { data, toUserId } = action.payload;
        const ref: Reference<SecurityPhoneRequestsCollection> = {
          path: {
            collection: PAYLOAD_TYPE,
            authUid: toUserId,
          },
        };

        // Only merge if it requires ID validation after secure phone update
        if (data.id_verification_required) {
          return mergeWebsocketDocuments<SecurityPhoneRequestsCollection>(
            state,
            transformIntoDocuments(
              [{ change_request: data.secure_phone }],
              transformSecurityPhoneRequest,
              ref.path.authUid,
            ),
            ref,
          );
        }
      }

      return state;
    }

    default:
      return state;
  }
}
